
























import { Component, Watch, Vue, Prop } from 'vue-property-decorator';


@Component({
  components: {},
})
export default class Timer extends Vue {
  private intervalId: NodeJS.Timeout;
  private startTime: number = 0 ;
  private deltaTime: number = 0;

  public get displayValue() {
    const time = Math.round(this.deltaTime / 100) / 10;
    const seconds = (time % 60).toFixed(1).padStart(4, '0');
    const minutes = Math.floor(time / 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  public get displayValueCircle() {
    return Math.ceil(this.deltaTime / 1000).toString().padStart(2, '0');
  }

  public get progressValueCircle() {
    if (this.initial) {
      return (this.deltaTime / (this.initial * 1000)) * 100;
    }
    return 0;
  }

  public get isCountdown() {
    return this.type === 'countdown';
  }

  public created() {
    this.setDeltaTime();
  }

  @Prop()
  public type: string;

  private get direction() {
    return this.isCountdown ? 'down' : 'up';
  }

  @Prop()
  public initial: number;

  @Prop()
  public value: number;

  @Prop()
  public title: string;

  public isPlaying: boolean = false;

  private get initialValue() {
    const defaultVal = this.isCountdown ? 60 : 0;
    return this.initial || defaultVal;
  }

  @Watch('value')
  public setDeltaTime() {
    this.deltaTime = (this.value || this.initialValue) * 1000;
  }

  public startStop() {
    if (this.isPlaying) {
      if (this.isCountdown) {
        this.clear();
      } else {
        this.pause();
      }
    } else {
      this.play();
    }
    this.emitTime();
  }

  private tick() {
    const dirSign = (this.direction === 'down' ? 1 : -1);
    const oldDeltaTime = this.deltaTime;
    const newTime = (this.startTime - Date.now()) * dirSign;
    this.emitTime();
    if (this.shouldStop(oldDeltaTime, newTime)) {
        if (this.isCountdown) {
          this.clear();
        } else {
          this.pause();
          this.deltaTime = 0;
        }
    } else {
      this.deltaTime = Math.abs(newTime);
    }
  }

  private play() {
    const dirSign = (this.direction === 'down' ? 1 : -1);
    this.startTime = Date.now() + this.deltaTime * dirSign;
    this.intervalId = setInterval(this.tick, 100);
    this.isPlaying = true;
    this.emitStartStop();
  }

  private shouldStop(oldTime: number, newTime: number): boolean {
    if (this.direction === 'up') {
      return false;
    }
    if ((oldTime > 0 && newTime <= 0) || (newTime < 0)) {
      return true;
    }
    return false;
  }

  private pause() {
    clearInterval(this.intervalId);
    this.isPlaying = false;
    this.emitStartStop();
  }

  public clear() {
    this.pause();
    this.deltaTime = this.initialValue * 1000;
    this.emitTime();
  }

  private emitTime() {
    this.$emit('changed', this.deltaTime / 1000);
  }

  private emitStartStop() {
    this.$emit('input', this.deltaTime / 1000);
  }
}
